module.exports = __webpack_public_path__ + "static/ey-7-sq-0e6d33ab62bd56476536588ddcef028b.png";